// src/sentry.ts
import * as Sentry from "@sentry/react";
import { browserTracingIntegration } from "@sentry/react";

const env =
  import.meta.env.VITE_SENTRY_ENV ||
  import.meta.env.MODE ||
  "development";

const defaultTracesSampleRate =
  env === "production" || env === "vercel-production"
    ? 0.1
    : env === "vercel-preview" || env === "preview"
    ? 0.02
    : 0.0;

const tracesSampleRate =
  import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE !== undefined
    ? Number(import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE)
    : defaultTracesSampleRate;

// In prod, set VITE_SENTRY_RELEASE to VERCEL_GIT_COMMIT_SHA.
// In dev, use a dummy release so Sentry doesn't warn about sessions.
const release =
  import.meta.env.VITE_SENTRY_RELEASE ||
  (import.meta.env.DEV ? "dev-local" : undefined);

// If there is no DSN, completely skip real Sentry init.
// This makes dev super safe, and prod still works as long as DSN is set.
const dsn = import.meta.env.VITE_SENTRY_DSN;

if (dsn) {
  // Normal Sentry init (prod + any env where DSN is defined)
  Sentry.init({
    dsn,
    environment: env,
    release,
    tracesSampleRate,
    integrations: [browserTracingIntegration()],
    debug: import.meta.env.DEV,
  });

  // Expose real Sentry for console testing in dev
  if (typeof window !== "undefined" && import.meta.env.DEV) {
    (window as any).Sentry = Sentry;
  }
} else {
  // No DSN → Sentry is effectively disabled.
  // Provide a tiny no-op shim in dev so `window.Sentry` calls don't explode.
  if (typeof window !== "undefined" && import.meta.env.DEV) {
    (window as any).Sentry = {
      captureException: (..._args: any[]) => {},
      captureMessage: (..._args: any[]) => {},
      withScope: (fn: (scope: any) => void) => fn({}),
    };
  }
}
